import { Button } from "@volca/ui/components/ui/button";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface RosterUnpublishedChangesBarProps {
  changeCount: number;
  busy: boolean;
  discarding: boolean;
  onDiscard: () => void;
  onReview: () => void;
}

export const RosterUnpublishedChangesBar = ({
  changeCount,
  busy,
  discarding,
  onDiscard,
  onReview,
}: RosterUnpublishedChangesBarProps) => (
  <Stack
    direction="row"
    align="center"
    justify="between"
    gap={4}
    className="w-full shrink-0 flex-wrap rounded-xl border border-warning-line bg-warning-subtle px-4 py-3"
  >
    <Stack align="start" gap={0}>
      <Text variant="label">
        {changeCount} unpublished {changeCount === 1 ? "change" : "changes"}
      </Text>
      <Text variant="caption" className="text-subtle">
        Publishing saves a new version; past runs keep the version they used.
      </Text>
    </Stack>
    <Stack direction="row" align="center" gap={2}>
      <Button
        variant="ghost"
        size="sm"
        disabled={busy || discarding}
        aria-busy={discarding || undefined}
        onClick={onDiscard}
      >
        {discarding && <Spinner data-icon="inline-start" aria-hidden />}
        Discard changes
      </Button>
      <Button size="sm" disabled={busy} onClick={onReview}>
        Review changes
      </Button>
    </Stack>
  </Stack>
);
